/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateVestingCategoryDto } from '../../models/create-vesting-category-dto';
import { ProjectResponseAdminDto } from '../../models/project-response-admin-dto';

export interface AdminProjectsControllerAddOrUpdateVestingCategoryV1$Params {
  projectId: string;
      body: CreateVestingCategoryDto
}

export function adminProjectsControllerAddOrUpdateVestingCategoryV1(http: HttpClient, rootUrl: string, params: AdminProjectsControllerAddOrUpdateVestingCategoryV1$Params, context?: HttpContext): Observable<StrictHttpResponse<ProjectResponseAdminDto>> {
  const rb = new RequestBuilder(rootUrl, adminProjectsControllerAddOrUpdateVestingCategoryV1.PATH, 'patch');
  if (params) {
    rb.path('projectId', params.projectId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProjectResponseAdminDto>;
    })
  );
}

adminProjectsControllerAddOrUpdateVestingCategoryV1.PATH = '/v1/admin/projects/{projectId}/vesting-categories';
